module.exports = __webpack_public_path__ + "static/img/logo_bg.e7bf12c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/logo_bg.jpg
// module id = gVAk
// module chunks = 18